"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages = {
    boolean: 'Expected type is "Boolean".',
};
exports.default = messages;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/boolean/messages.js
// module id = 322
// module chunks = 0